<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px"   v-if="isCustomer || (!isCustomer && (form.id == null||this.form.id == '')) ">
      <breadcrumb></breadcrumb>
    </el-header> 
    <el-main v-loading.fullscreen.lock="loading">
      <el-form :model="form" ref="form" label-width="150px" :rules="rules">
        <el-row :gutter="10">
          <el-col :span="12" v-if="form.requestNo != ''">
            <el-form-item :label="$t('field.docNo')" >
              <el-input v-model="form.requestNo" :disabled="true"></el-input>
            </el-form-item>
          </el-col>         
          <el-col :span="12" > 
            <CustomerSearch v-model="form.custSapCode"  @sync-select-customer="syncSelectCustomer" v-if="(!isCustomer && (form.status == null|| form.status == ''))" />
            <el-form-item :label="$t('field.customerNo')" v-if="(form.status !=null && form.status !='') " >
              <el-input v-model="form.custSapCode"  :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('field.customerNo')"  v-if="isCustomer &&(form.status ==null || form.status =='') " >
              <el-select v-model="form.custSapCode" :placeholder="$t('msg.pleaseSelect')" style="width:100%"  :disabled="onlyView">
                <el-option v-for="item in custSapNoOpts"  :key="item.key"  :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>

          </el-col>      
        </el-row>
        <el-row :gutter="10">   
          <el-col :span="12" >
            <el-form-item :label="$t('field.requestAccount')" >
              <el-input v-model="form.applyAccount" :disabled="true"></el-input>
            </el-form-item>
          </el-col> 
          <el-col :span="12" v-if="form.requestNo != ''">
            <el-form-item :label="$t('field.status')" >
              <el-input v-model="form.status" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('field.symptom')" prop="symptom" >
              <el-input  type="textarea" rows=3 v-model="form.symptom" show-word-limit :placeholder="$t('field.briefDescription')" maxlength=5000 :disabled="onlyView"></el-input>
            </el-form-item>
          </el-col>
        </el-row>      
        <FeedbackProductType ref='feedbackProductType' :custNo.sync="form.custSapCode" :onlyTable="onlyView"  :pFeedbackId="form.id"
         @updateProductTypeData="syncProductTypeData"/>
        <br>
        <el-row>
          <el-col :span="15">
            <el-form-item :label="$t('field.systemNameandType')" label-width="250px" prop="systemName">
              <el-select v-model="form.systemName" :placeholder="$t('msg.pleaseSelect')" style="width:100%"  :disabled="onlyView">
                <el-option v-for="item in systemNameOpts"  :key="item"  :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="1" style="margin: 3px;"></el-col>
          <el-col :span="7">
            <el-input v-model="form.systemNameComment" maxlength=200 :placeholder="$t('field.systemNameandTypeHint')" :disabled="onlyView"></el-input>
          </el-col>   
        </el-row> 
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('field.detailsincaseofRetrofit')" label-width="250px" prop="retrofit">
              <el-input v-model="form.retrofit" :placeholder="$t('field.detailsincaseofRetrofitHint')"  maxlength=500  :disabled="onlyView"></el-input>
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('field.hospitalName')" label-width="250px" prop="hospitalName">
              <el-input v-model="form.hospitalName" maxlength=500  :disabled="onlyView"></el-input>
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('field.country')" label-width="250px" prop="country">               
              <el-select v-model="form.country" :placeholder="$t('msg.pleaseSelect')"  :disabled="onlyView" filterable >
                <el-option v-for="item in countryOpts"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">  
            <el-form-item :label="$t('field.frequencyofQuestions')"   prop="frequency" label-width="185px">                
              <el-select v-model="form.frequency" :placeholder="$t('msg.pleaseSelect')"  :disabled="onlyView">
                <el-option v-for="item in frequencyOpts"  :key="item"  :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item  :label="$t('field.detailedDescription')" label-width="250px">
            <el-input type="textarea" v-model="form.description" maxlength=5000  :disabled="onlyView" show-word-limit rows=3></el-input>
          </el-form-item>
        </el-col>
      </el-row> 
      <FileEditList ref="fileList" :onlyView="fileListOnlyView" :docId.sync="form.id" uploadType="feedback"  @sync-save-status="syncFileSave" :directSave.sync="fileListDirectSave"/>
      <br>
      <el-row>
        <el-col :span="20">
          <el-form-item :label="$t('field.issueType')" prop="issueType">  
            <el-select v-model="form.issueType" :placeholder="$t('msg.pleaseSelect')" style="width:100%" @change="issueTypeChange"  :disabled="onlyView" >
              <el-option v-for="item in issueTypeOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>    
      <div v-if="form.issueType == issueTypeOpts[0]" class="issueType">
        <el-form ref="issueTypeDiv1" label-width="450px" >
          <el-row>
            <el-col :span="22"><h4>1. {{$t('field.dataCollected')}}</h4></el-col>
            <el-col :span="2"><h4>Done</h4></el-col>             
          </el-row>   
          <el-row>
            <el-col :span="22" style="padding-right:10px">
              <span style="color: red; padding-right: 5px;">*</span><span>1. {{$t('field.imageQualityIssueCheck1')}}</span>
            </el-col>
              <el-col :span="2"><el-checkbox  v-model="form.check1"  :disabled="onlyView"></el-checkbox></el-col>             
          </el-row><br>
          <el-row>
            <el-col :span="22" style="padding-right:10px">
              <span style="color: red; padding-right: 5px;">*</span><span>2. {{$t('field.imageQualityIssueCheck2')}}</span>
            </el-col>
              <el-col :span="2"><el-checkbox  v-model="form.check2"  :disabled="onlyView"></el-checkbox></el-col>             
          </el-row><br>
          <el-row>
            <el-col :span="22" style="padding-right:10px">
              <span style="color: red; padding-right: 5px;">*</span><span>3. {{$t('field.imageQualityIssueCheck3')}}</span>
            </el-col>
              <el-col :span="2"><el-checkbox  v-model="form.check3"  :disabled="onlyView"></el-checkbox></el-col>             
          </el-row><br>
          <el-row> 
            <el-col :span="22" style="padding-right:10px">
              <span style="color: red; padding-right: 5px;">*</span><span>4. {{$t('field.imageQualityIssueCheck4')}}</span>
            </el-col>
              <el-col :span="2"><el-checkbox  v-model="form.check4"  :disabled="onlyView"></el-checkbox></el-col>             
          </el-row><br>
          <el-row>
            <el-col :span="22" style="padding-right:10px">
              <span style="color: red; padding-right: 5px;">*</span><span>5. {{$t('field.sendDataToINCX')}}</span>
            </el-col>
              <el-col :span="2"><el-checkbox  v-model="form.check5"  :disabled="onlyView"></el-checkbox></el-col>             
          </el-row>
          <el-row>
            <el-col :span="24"><h4>2. {{$t('field.InformationImageIssue')}}</h4></el-col>                  
          </el-row>     
          <el-form-item :label="$t('field.lineArtifactLocation')"  required>               
            <el-select v-model="form.lineLoc" :placeholder="$t('msg.pleaseSelect')"  style="width:100%"  :disabled="onlyView">
              <el-option v-for="item in lineLocOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('field.artifactRelatesDelectorOrientation')" required >                
            <el-select v-model="form.artifact" :placeholder="$t('msg.pleaseSelect')" style="width:100%"  :disabled="onlyView">
              <el-option v-for="item in artifactOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('field.ghostArtifact')" required>                
            <el-select v-model="form.ghostArtifact" :placeholder="$t('msg.pleaseSelect')" style="width:100%"  :disabled="onlyView">
              <el-option v-for="item in ghostArtifactOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('field.detectorIntegrationTime')" required>                
            <!--<el-select v-model="form.integrationTime" :placeholder="$t('msg.pleaseSelect')" style="width:100%"  :disabled="onlyView">
              <el-option v-for="item in integrationTimeOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>-->
            <el-input v-model="form.integrationTime" maxlength=200 :disabled="onlyView"></el-input>
          </el-form-item>
          <el-form-item :label="$t('field.detectorMode')" required >                
            <el-select v-model="form.detectorMode" :placeholder="$t('msg.pleaseSelect')" style="width:100%"  :disabled="onlyView">
              <el-option v-for="item in detectorModeOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('field.modalityPosition')" required>                
            <el-select v-model="form.modalityPosition" :placeholder="$t('msg.pleaseSelect')" style="width:100%" :disabled="onlyView">
              <el-option v-for="item in modalityPositionOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('field.gridforExposure')" required>                
            <el-select v-model="form.exposureGrid" :placeholder="$t('msg.pleaseSelect')" style="width:100%" :disabled="onlyView">
              <el-option v-for="item in exposureGridOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="kV" required>                
            <el-input v-model="form.kv" maxlength=200 :disabled="onlyView"></el-input>
          </el-form-item>
          <el-form-item label="mAs(or mA, S / mA,mS)" required >                
            <el-input v-model="form.mas" maxlength=200 :disabled="onlyView"></el-input>
          </el-form-item>
          <el-form-item  :label="$t('field.sidInCm')" required>                
            <el-input v-model="form.sourceDistance" maxlength=200 :disabled="onlyView"></el-input>
          </el-form-item>
          <el-form-item :label="$t('field.additionalTubeFltration')" required>                
            <el-select v-model="form.tubeFltration" :placeholder="$t('msg.pleaseSelect')" style="width:100%" :disabled="onlyView">
              <el-option v-for="item in tubeFltrationOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('field.fileRemark')" >                
            <el-input v-model="form.issueComment" maxlength=500 :disabled="onlyView"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="form.issueType == issueTypeOpts[1]" class="issueType">
        <div style="padding-left:10px">      
          <h4>{{$t('field.imageQualityIssueComment')}}<br>
          {{$t('field.examples')}}:<br>
          * {{$t('field.imageQualityIssueComment1')}}<br>
          * {{$t('field.imageQualityIssueComment2')}}<br>
          * {{$t('field.imageQualityIssueComment3')}}<br>
          * {{$t('field.imageQualityIssueComment4')}}<br></h4>
          </div>
          <el-form ref="issueTypeDiv1" label-width="400px" >
            <el-row>
              <el-col :span="20" style="padding-right:10px"><h4>1. {{$t('field.dataCollected')}}</h4></el-col>
              <el-col :span="4"><h4>Done</h4></el-col>             
            </el-row>          
            <el-row>
              <el-col :span="20" style="padding-right:10px">
                <span style="color: red; padding-right: 5px;">*</span><span>1. {{$t('field.sendDataToINCX')}}</span>
              </el-col>
              <el-col :span="4"><el-checkbox  v-model="form.check1" :disabled="onlyView"></el-checkbox></el-col>              
            </el-row>
            <el-row>
              <el-col :span="20" style="padding-right:10px">
                <span style="color: red; padding-right: 5px;">*</span><span>2. {{$t('field.otherImageQualityIssueCheck2')}}</span>
              </el-col>
              <el-col :span="4"><el-checkbox  v-model="form.check2" :disabled="onlyView"></el-checkbox></el-col>              
            </el-row>
            <el-row>
              <el-col :span="20"><h4>2. {{$t('field.InformationImageIssue')}}</h4></el-col>                  
            </el-row>     
            <!--
            <el-form-item :label="$t('field.issueOccurrenceDate')" label-width="250px" required>               
              <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="form.issueDate" :disabled="onlyView"></el-date-picker>
            </el-form-item>      -->      
            <el-form-item :label="$t('field.fileRemark')" label-width="250px" >      
              <el-input type="textarea" v-model="form.issueComment" maxlength=500 :disabled="onlyView" show-word-limit ></el-input> 
            </el-form-item>
            <el-row>
              <el-col :span="20"><h4>3. {{$t('field.picturesVideos')}}</h4></el-col>
              <el-col :span="4"><h4>Done</h4></el-col>             
            </el-row>
            <el-row>
              <el-col :span="20" style="padding-right:10px">
                <span>{{$t('field.documentForProblem')}}</span>
              </el-col>
                <el-col :span="4"><el-checkbox  v-model="form.check6" :disabled="onlyView"></el-checkbox></el-col>             
            </el-row>
          </el-form>
        </div>
        <el-row style="padding-top: 10px;text-align:center" v-if="(isCustomer || (!isCustomer && (form.id == null||this.form.id == '')) ) && !onlyView">  
          <el-col :span="24" >
            <el-button type="warning" @click="submitFeedback()">{{$t('button.submit')}}</el-button>        
          </el-col>  
        </el-row>
        <div v-if="isCustomer && form.requestNo !=null && form.requestNo != ''" style="text-align:center;"><h3>The following is the reply from the INCX staff 以下是INCX人員回覆的內容</h3></div>
        <hr v-if="isCustomer && form.requestNo !=null && form.requestNo != ''"/>
        <FeedbackComm v-if="isCustomer && form.requestNo !=null && form.requestNo != ''" ref="feedbackViewComm" :lockAnalysisReport="true" :pFeedbackId="form.id"/>
       
        <div v-if="isCustomer && form.requestNo !=null && form.requestNo != ''" >
          <h3>Software Update</h3>
            <div class="workContent">
              <el-form-item label="Purpose">
                  <el-checkbox-group v-model="softwareArr" :disabled="onlyView">
                    <el-checkbox label="Bug" name="software"></el-checkbox>
                    <el-checkbox label="Application" name="software"></el-checkbox>
                    <el-checkbox label="Requirement" name="software"></el-checkbox>
                   <!-- <el-checkbox label="Middle board" name="mechanism"></el-checkbox> -->
                    <el-checkbox label="System Issue (Not INCX Issue)" name="software"></el-checkbox>                
                  </el-checkbox-group>
                </el-form-item>
          </div>       
        </div>
        <br>
        <div style="width:725px; overflow:auto" v-if="isCustomer && form.requestNo !=null && form.requestNo != ''">
          <h3>Hardware RMA Information</h3>
        <el-table ref="rmaTable" :data="rmaTable.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')" >
          <el-table-column v-for="(v, i) in rmaTable.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
            <template slot-scope="scope">          
              <span>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>        
        </el-table>
        </div>
      </el-form>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb';
import CommonUtil from "../../utils/commonUtil.js";
import FileEditList from "../components/FileEditList";
import FeedbackProductType from "../components/customerManage/FeedbackProductType";
import CustomerSearch from "../components/CustomerSearch";
import FeedbackComm from "../components/customerManage/FeedbackComm";

import { apiSaveFeedback, apiFindSysAttrValueByCategory, apiFindSystemNameAndType, apiFindFeedback,apiGetFeedbackAuth, apiFindFeedbackRmaByFeedbackId,
         apiFindCustSapNoByWindowsAccount  } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {
  name: 'createFeedback',
  data() {   
    return {    
      loading:false, 
      onlyView: false,   
      fileListOnlyView:false,
      fileListDirectSave:false,
      otherStr:'Other',
      form: {       
        id:'',
        requestNo:'',
        custSapCode:'',   
        symptom:'',
        systemName:'',
        systemNameComment:'',
        retrofit:'',            
        hospitalName:'',   
        country:'', 
        frequency:'',
        description:'',
        issueType:'',
        check1:'',              
        check2:'',             
        check3:'',              
        check4:'',              
        check5:'',              
        check6:'',   
        lineLoc:'',
        artifact:'',
        ghostArtifact:'',
        integrationTime:'',
        detectorMode:'',
        modalityPosition:'',
        exposureGrid:'',
        kv:'',
        mas:'',
        sourceDistance:'',
        tubeFltration:'',
        issueComment:'',       
        issueDate:'',          
        applyDate:'',          
        applyAccount:'',   
        status:'',
        software:'',
	      softwareComment:''
      },
      softwareArr:[],
      rules: {
        symptom: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' } ],
        systemName: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        retrofit: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' } ],
        hospitalName: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' } ],
        country: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        frequency: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        issueType:[ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
      },
      countryOpts:[],
      frequencyOpts:['Persistent 持續發生','Sporadic(arbitrary) 偶爾發生','~1 of 2 exposures 拍攝兩次發生一次','~1 of 5 exposures 拍攝五次發生一次',
                    '~1 of 10 exposures 拍攝十次發生一次','1 of >10 exposures 拍攝十次以上發生一次','Other 其他'],
      systemNameOpts:[],
      lineLocOpts:["There is no line artifact 沒有線缺陷","Artifact is always on the same line 線缺陷於固定位置","Artifact move to different locations on the image 線缺陷任意位置移動"],
      artifactOpts:['Yes','No','It was impossible to exposure with panel 90 degree related 旋轉90度，探測器無法曝光'],
      ghostArtifactOpts:['Yes','No'], 
      integrationTimeOpts:['700ms','1200ms','2200ms','3200ms','4200ms'], 
      detectorModeOpts:['Synchronized 同步模式','Auto-trigger 自動曝光偵測模式'],
      modalityPositionOpts:['Table 平台式','Wallstand 直立式','Free Exposure 非固定式'], 
      exposureGridOpts:['103 lp/mm','125 lp/mm','None(Free Exposure)','Other-please specify in comments'], 
      tubeFltrationOpts:['25mmAl 25 mm 鋁濾片','Other-please specify in comments 其他 – 請將規格填於註解欄位','Unknown 未知', 'No filter or grid 無濾片'],
      issueTypeOpts:['Image Quality Issue 影像問題','Other Issue 其他問題'],
      custSapNoOpts:[],
      isCustomer:false,
      productTypeData:[],
      saveSuccess:false,
      saveFileSuccess:false,
      rmaTable:{
        columns: [
          { field: "modelName", title:'Model Name', width: 180},
          { field: "productId", title:'ProductID', width: 180},
          { field: "serialNo", title:'Serial No', width: 180},      
          { field: "rmaNumber", title:'RMA Number', width: 180}    
        ],
        data: []
      },
    };
  },   
  props: {    
    pFeedbackId: {
      type: String
    },
    pOnlyView:{
      type:Boolean,
      default:false
    }

  },
  components: {
    Breadcrumb,
    FileEditList,
    FeedbackProductType,
    CustomerSearch,
    FeedbackComm
  },
  mounted() {     
    apiFindSysAttrValueByCategory({ headers: authHeader(), condition: 'COUNTRY'}).then((response) => { 
      response.data.forEach((item, index) => {   
        this.countryOpts.push({ value: item.key, label: item.key +' '+ item.value });
      });
    }).catch((err) => {
      console.log(err);
    });

    this.loadSystemNameandType();    
    if(this.form.id!= null && this.form.id!= ''){
      
      apiFindFeedback({ headers: authHeader(), feedbackId: this.form.id}).then((response) => { 
        if(response.status== 200 && response.data != null){
          response.data.check1 = (response.data.check1 == 1 ? true:false);
          response.data.check2 = (response.data.check2 == 1 ? true:false);
          response.data.check3 = (response.data.check3 == 1 ? true:false);
          response.data.check4 = (response.data.check4 == 1 ? true:false);
          response.data.check5 = (response.data.check5 == 1 ? true:false);
          response.data.check6 = (response.data.check6 == 1 ? true:false);
       
          this.form = response.data;     
          this.softwareArr = CommonUtil.strToArr(this.form.software);     
          debugger
          this.fileListOnlyView = (this.form.status == 'Under Review'|| this.form.status == 'Closed'|| this.form.status == 'Cancelled' || this.pOnlyView ? true: false);
          if(!this.fileListOnlyView ){
            this.fileListDirectSave = true;
          } 
          if(!CommonUtil.isNull(this.form.issueDate)){
            this.form.issueDate = CommonUtil.dateFormatDate(new Date(this.form.issueDate));
          }
          this.onlyView = true;
          if(!this.isCustomer && this.form.custSapCode != null && this.form.custSapCode!= ''){        
            apiGetFeedbackAuth({ headers: authHeader(), condition: this.form.custSapCode}).then((response) => {      
              if(response.data){
                this.onlyView = (this.form.status != 'Under Review'  && this.form.status != 'Closed' && this.form.status != 'Cancelled' ? false : true );           
              }else{
                this.onlyView = true;
              }
              if(this.onlyView){
                this.fileListOnlyView = true;
              }
            }).catch((err) => {
              console.log(err);
            });
          }
        }
      }).catch((err) => {
        console.log(err);
      });

      if(this.isCustomer){
        apiFindFeedbackRmaByFeedbackId({ headers: authHeader(), feedbackId: this.form.id}).then((response) => { 
          
          if(response.status== 200 && response.data != null && response.data.length > 0){          
            this.rmaTable.data = response.data;
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    }
    
    
  },
  watch:{
    "form.custSapCode": function(){
      this.$emit('sync-custNo', this.form.custSapCode);
    },
    '$route':function(){
      if(this.$route.fullPath == '/createFeedback'){
        location.reload()
      }
    }
  },
  created(){
    this.isCustomer = this.$store.state.auth.user.username.indexOf('@')>-1 ? true : false;    
    if(this.$route.params.id == null || this.$route.params.id == ''){
      this.form.id = this.pFeedbackId;
    }else{
      this.form.id = this.$route.params.id;
    }  
    // this.isCustomer = (this.pFeedbackId == undefined);
    if(this.isCustomer){
      apiFindCustSapNoByWindowsAccount({ headers: authHeader()}).then((response) => { 
        if(response.status== 200 && response.data != null){
          this.custSapNoOpts = response.data;
          this.form.custSapCode = this.custSapNoOpts[0].key;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
    if(CommonUtil.isNull(this.form.requestNo)){
      this.form.applyAccount = this.$store.state.auth.user.username;
    }
    
  },
  methods: {
    loadSystemNameandType(){
      this.systemNameOpts=[];
      this.form.systemName='';   
      apiFindSystemNameAndType({ headers: authHeader(), custSapCode: this.form.custSapCode}).then((response) => {
        response.data.forEach((item, index) => {   
          this.systemNameOpts.push(item.value);
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    submitFeedback(){

      //step 1. Symptom, systemName retrofit hospitalName country frequency不得為空
      this.$refs['form'].validate((valid) => {
        if (!valid) {
         return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
        }else{
          //step 2. Product Type表格筆數要大於0     
          if(this.$refs.feedbackProductType.productTypeTable.data.length == 0){
            return this.$message.warning({message: this.$i18n.t('msg.productTypeNotEmpty'), duration: 800});
          }
          //step 3. issueType            
          var checkIssueComplete = false;
 
          if(this.form.issueType == this.issueTypeOpts[0] ){
            if(this.form.check1 == '' || this.form.check2 == '' || this.form.check3 == '' || this.form.check4 == '' || this.form.check5 == '' || this.form.lineLoc == '' || 
              this.form.artifact == '' || this.form.ghostArtifact == '' || this.form.integrationTime == '' || this.form.detectorMode == '' || this.form.modalityPosition == '' || 
              this.form.exposureGrid == '' || this.form.kv == '' || this.form.mas == '' || this.form.sourceDistance == '' || this.form.tubeFltration == '' ){
              checkIssueComplete = true;
            }
          } else if(this.form.issueType == this.issueTypeOpts[1] ){      
            if(this.form.check1 == '' ||  this.form.check2== ''){
              checkIssueComplete = true;
            }
          }        
          if(checkIssueComplete){
            return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
          }

          //step 4. systemName 為Other的話systemNameComment不得為空
          if(this.form.systemName.indexOf('Other') > -1 && this.form.systemNameComment == ''){
            return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
          }
          //step 5. 儲存feedback
          this.form.check1 = (this.form.check1==true ? 1 : 0);
          this.form.check2 = (this.form.check2==true ? 1 : 0);
          this.form.check3 = (this.form.check3==true ? 1 : 0);
          this.form.check4 = (this.form.check4==true ? 1 : 0);
          this.form.check5 = (this.form.check5==true ? 1 : 0);
          this.form.check6 = (this.form.check6==true ? 1 : 0);
          this.loading = true;
          apiSaveFeedback({
            headers: authHeader(), 
            feedback: this.form,
            productTypes: this.$refs.feedbackProductType.productTypeTable.data
            }).then((response) => {
              if(response.data){           
                this.form = response.data.feedback;     
                this.saveSuccess = true;      
                this.$refs.fileList.docId = this.form.id;  //TODO這行會出錯                          
                //step 6. 取得feedback的id後存表格資料
                this.$refs.fileList.save();
               
                //需等到file都存檔完後才完成save,詳syncFileSave
              }else{
                this.loading = false;
                this.saveSuccess = false;        
              }
            }).catch((err) => {
              this.loading = false;
              this.saveSuccess = false;
            });
          }
        });  
    },
    resetIssueForm(){
      this.form.check1='';
      this.form.check2='';
      this.form.check3='';             
      this.form.check4='';
      this.form.check5='';
      this.form.check6='';
      this.form.lineLoc='';
      this.form.artifact='';
      this.form.ghostArtifact='';
      this.form.integrationTime='';
      this.form.detectorMode='';
      this.form.modalityPosition='';
      this.form.exposureGrid='';
      this.form.kv='';
      this.form.mas='';
      this.form.sourceDistance='';
      this.form.tubeFltration='';
      this.form.issueComment='';
      this.form.issueDate='';
 
    },
    issueTypeChange(){      
      this.resetIssueForm();
    },
    syncSelectCustomer(custNo){            
      this.form.custSapCode = custNo;
      this.$refs.feedbackProductType.productType = '';
      this.loadSystemNameandType();
    },
    syncProductTypeData(data){
      this.productTypeData = data;
    },
    syncFileSave(status){  
      if(this.$route.fullPath.indexOf('/createFeedback') != -1){
        if(this.saveSuccess == true && status == true){
          this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
          this.loading = false;
          if(this.isCustomer){
            setTimeout(( () => this.$router.push("/FeedbackList/" )), 900);
          }else{
            setTimeout(( () => this.$router.push("/customerFeedbackHandling/" )), 900);
          }
          
        }else{
          this.loading = false;
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
        }
      }else{
        //this.$router.push("/ProcessFeedback/" +  this.form.id);
        this.$emit('sync-cust-feedback-file-save', status);   
        this.loading = false;
      }
    }
  }
};
</script>

<style >
.el-select .el-select--small {
  width: 100%;
}

input {
  width: 100%;
}

.issueType {
  background:#ff00000d;
  padding-right: 5px;
  overflow: auto;
  font-size: 14px;
  padding-left: 10px;
  padding-bottom: 10px;
}


</style>